import { getImageBorderProps } from '../../utils/helper';
import { GuaranteeData } from './customerGuarantees';

export const Guarantee = ({
  id,
  image,
  name,
  description,
  maxWidth,
  height,
  hideImage,
  imageBorder,
  currentDeviceType,
}: GuaranteeData) => {
  return (
    <div key={id} className="flex items-start mt-10">
      {!hideImage && (
        <img
          style={{
            maxWidth: isNaN(+maxWidth[currentDeviceType])
              ? maxWidth[currentDeviceType]
              : +maxWidth[currentDeviceType],
            height: isNaN(+height[currentDeviceType])
              ? height[currentDeviceType]
              : +height[currentDeviceType],
            ...getImageBorderProps(imageBorder, currentDeviceType),
          }}
          src={`${image?.imageUrl ? process.env.REACT_APP_S3_BUCKET_URL + image?.imageUrl : 'https://t4.ftcdn.net/jpg/05/11/55/91/360_F_511559113_UTxNAE1EP40z1qZ8hIzGNrB0LwqwjruK.jpg'}`}
          alt={image?.fileName}
          decoding="async"
        />
      )}
      <div className="ml-2">
        <div className="flex">
          <div className="flex items-center">
            <p className="font-bold text-sm">{name}</p>
          </div>
        </div>
        <dt className="text-gray-600 text-sm">{description}</dt>
      </div>
    </div>
  );
};
